import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

export function CalendarTopBar({ t, closeCalendar, clearCalendar, enableBodyScroll, calendarInfo }) {
    return (
        <div className="calendar-top-bar">
            <div className="u-size1of1 calendar-top-bar-navigation-container">
                <button
                    className="form-grid-unit button button--flat button--small u-ma16"
                    data-testid="clear-calendar"
                    onClick={clearCalendar}>
                    {t('calendar_extra.clear')}
                </button>
                <button
                    className="form-grid-unit u-text-right button button--cta button--small u-ma16"
                    data-testid="close-calendar"
                    onClick={() => {
                        closeCalendar();
                        enableBodyScroll();
                    }}>
                    {t('calendar_extra.close')}
                </button>
            </div>
            {calendarInfo}
        </div>
    );
}

CalendarTopBar.propTypes = {
    t: PropTypes.func.isRequired,
    closeCalendar: PropTypes.func.isRequired,
    clearCalendar: PropTypes.func.isRequired,
    enableBodyScroll: PropTypes.func.isRequired,
    calendarInfo: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
};

export default withTranslation('search')(CalendarTopBar);
